import PubSub from "underpub-js";
import sharer from "sharer.js";
import { gsap } from "gsap";

var HeroArticleDetail = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-HeroArticleDetail',
	};

	$.extend(true, this.options, options);

};

HeroArticleDetail.prototype.init = function() {

	var self = this;

	this.$social = this.options.$el.find(`.${self.options.baseClass}__social`);
	this.$socialLinksWrapper = this.$social.find(`.${self.options.baseClass}__social__linksWrapper`);
	this.socialOpenClass = `${self.options.baseClass}__social--active`;
	this.active = false;

	// for mobile, when heading is clicked
	this.options.$el.find(`.${self.options.baseClass}__social__heading`).on('click', function() {

		if (self.active)
		{
			self.close();
		}
		else
		{
			self.open();
		}

	});

	this.options.$el.find(`.${self.options.baseClass}__social`).on('mouseenter', function() {
console.log('mouse enter');
		self.open();

	});

	this.options.$el.find(`.${self.options.baseClass}__social`).on('mouseleave', function() {

		self.close();

	});

};

HeroArticleDetail.prototype.open = function() {

	var self = this;

	self.$social.addClass( self.socialOpenClass );

	gsap.to(self.$socialLinksWrapper, {
		height: "auto",
		duration: 0.3
	});

	this.active = true;

};

HeroArticleDetail.prototype.close = function() {

	var self = this;

	self.$social.removeClass( self.socialOpenClass );

	gsap.to(self.$socialLinksWrapper, {
		height: 0,
		duration: 0.3,
		delay: 0.3
	});

	this.active = false;

};

export default HeroArticleDetail;
